import InvoiceClient from "../../../../pages/Transactions/InvoiceClient";
import InvoiceClientNewEdit from "../../../../pages/Transactions/InvoiceClient/NewEdit";
import InvoiceClientDetail from "../../../../pages/Transactions/InvoiceClient/Detail";

const routerInvoiceClient = [
    {
        key: "invoice-client",
        path: "/transactions/invoice-client",
        element: <InvoiceClient />,
    },
    {
        key: "invoice-client-new",
        path: "/transactions/invoice-client/new",
        element: <InvoiceClientNewEdit />,
    },
    {
        key: "invoice-client-detail",
        path: "/transactions/invoice-client/:id",
        element: <InvoiceClientDetail />,
    },
];

export default routerInvoiceClient;
